module.exports = __webpack_public_path__ + "img/stick-guy.5308ab4c.svg";